<template>
  <div data-v-0a914d54="" class="games-page-inner">
    <img style="width: 100%" src="/static/image/73b07f2.jpg" alt="" />

    <div data-v-0a914d54="" class="games-page-content" style="padding-top: 12px">
      <div data-v-0a914d54="" class="games-tab-wrapper">
        <!-- stuck -->
        <ul data-v-0a914d54="" class="games-tab clearfix">
          <li data-v-0a914d54="" :class="gamecode == null ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode(null)">推荐</li>
          <li data-v-0a914d54="" :class="gamecode == 'obgdy' ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode('obgdy')">OB电子</li>
          <li data-v-0a914d54="" :class="gamecode == 'fgdz' ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode('fgdz')">FG电子</li>
          <li data-v-0a914d54="" :class="gamecode == 'pp' ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode('pp')">PP电子</li>
          <li data-v-0a914d54="" :class="gamecode == 'ae' ? 'games-tab-item active' : 'games-tab-item'" @click="changgamecode('ae')">AE电子</li>
        </ul>
      </div>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == null">
        <!-- AT -->
        <li data-v-0a914d54="" v-for="(item, index) in gameList" :key="index" v-if="item.app_state == 1" class="game-list-item" @click="$parent.openGamePage(item.platform_name, item.game_code, '')">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="`/static/image/concise/${item.platform_name}dz.png`" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.name }}</h4>
        </li>
      </ul>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == 'obgdy'">
        <li data-v-0a914d54="" class="game-list-item" v-for="(item, index) in obgdyList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="item.gamepic" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.gamename }}</h4>
        </li>
      </ul>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == 'fgdz'">
        <li data-v-0a914d54="" class="game-list-item" v-for="(item, index) in fgdzList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="item.gamepic" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.gamename }}</h4>
        </li>
      </ul>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == 'pp'">
        <li data-v-0a914d54="" class="game-list-item" v-for="(item, index) in ppList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="item.gamepic" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.gamename }}</h4>
        </li>
      </ul>
      <ul data-v-0a914d54="" class="game-list clearfix" v-if="gamecode == 'ae'">
        <li data-v-0a914d54="" class="game-list-item" v-for="(item, index) in aeList" :key="index" @click="$parent.openGamePage(item.catecode, item.gamecode, '')">
          <div data-v-0a914d54="" class="game-cover-wrapper">
            <img data-v-0a914d54="" alt="" class="game-picture" :src="item.gamepic" lazy="loaded" />
          </div>
          <h4 data-v-0a914d54="" class="game-title">{{ item.gamename }}</h4>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'games',
  data() {
    return {
      gamecode: null,
      obgdyList: [],
      fgdzList: [],
      ppList: [],
      aeList: [],
      gameList: [],
    };
  },
  created() {
    let that = this;
    that.getGameList();
  },
  methods: {
    getGameList() {
      let that = this;
      that.$parent.showLoading();

      that.$apiFun.get('/api/game/list', { category: 'concise' }).then(res => {
        if (res.code == 200) {
          that.gameList = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    changgamecode(code) {
      let that = this;
      if (code == that.gamecode) {
        return;
      }
      that.gamecode = code;
      if (code != null) {
        that.gamelistBycode();
      }
    },
    gamelistBycode() {
      let that = this;

      let name = that.gamecode + 'List';
      if (that[name].length > 0) {
        return;
      }
      that.$parent.showLoading();

      that.$apiFun
        .post('/api/gamelistBycode', { gamecode: that.gamecode })
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that[name] = res.data;
          }
          setTimeout(() => {
            that.$parent.hideLoading();
          }, 2000);
        })
        .catch(res => {
          that.$parent.hideLoading();
        });
    },
  },
  mounted() {
    let that = this;
    var mySwiper = new Swiper('.swiper', {
      slidesPerView: '1',
    });
    $(window).scroll(function () {
      if ($(document).scrollTop() <= 50) {
        $('.header-container').removeClass('headerBg');
        $('#headerBefore').css('height', '');
      } else {
        $('.header-container').addClass('headerBg');
        $('#headerBefore').css('height', '50px');
      }
    });
  },
  updated() {
    let that = this;
  },
};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-4f15c2b0.7a52835c.css';
@import '../../../static/css/chunk-vendors.2272e24f.css';
@import '../../../static/css/chunk-commonPlugins.f49730d2.css';
.games-page-content .games-tab.stuck {
  position: fixed !important;
  top: 50px !important;
  z-index: 600 !important;
  width: 100% !important;
}
.games-page-content .game-list .game-cover-wrapper {
  height: 218px !important;
}
.games-page-content .game-list .game-picture {
  height: auto !important;
}

.games-page-content .games-tab .games-tab-item {
  margin: 0 8px !important;
  font-size: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/main/games.vue